import { StrictMode } from 'react'
import { logger } from './utils/logger'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './style.css'

// Globalny nasłuch beforeinstallprompt – musi być dodany jak najwcześniej,
// aby nie przegapić zdarzenia, zanim użytkownik wejdzie na zakładkę Instalacja.
// Zapisujemy event na window i emitujemy custom event dla hooków.
window.addEventListener('beforeinstallprompt', (e: any) => {
  try {
    e.preventDefault()
    ;(window as any).__deferredInstallPrompt = e
    window.dispatchEvent(new Event('pwa:beforeinstallprompt'))
    logger.debug('📱 [global] beforeinstallprompt przechwycony')
  } catch (err) {
    console.warn('⚠️ [global] beforeinstallprompt handler error:', err)
  }
})

window.addEventListener('appinstalled', () => {
  try {
    ;(window as any).__deferredInstallPrompt = null
    window.dispatchEvent(new Event('pwa:appinstalled'))
    logger.debug('📱 [global] appinstalled')
  } catch (err) {
    console.warn('⚠️ [global] appinstalled handler error:', err)
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Rejestracja Service Workera (produkcja)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', async () => {
    try {
      const res = await fetch('/serviceWorker.js', { method: 'HEAD' })
      if (res.ok) {
        await navigator.serviceWorker.register('/serviceWorker.js')
        logger.debug('✅ Service Worker zarejestrowany')
      } else {
        logger.debug('ℹ️ Brak /serviceWorker.js — pomijam rejestrację')
      }
    } catch (err) {
      console.warn('⚠️ Błąd rejestracji Service Workera:', err)
    }
  })
}